// Table globale rareté -> ball (identité visuelle de l'appli), éditable
// en Réglages par un admin. Chargée une fois au démarrage, passée en props
// jusqu'à ballForVariant (lib/balls.js) partout où une carte se dessine.

import { useState, useCallback, useEffect } from "react";
import { fetchRarityBalls, setRarityBall, deleteRarityBall } from "../lib/api";

export function useRarityBalls() {
  const [assignments, setAssignments] = useState({});

  const reload = useCallback(async () => {
    try {
      setAssignments(await fetchRarityBalls());
    } catch (err) { console.error(err); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const setBall = useCallback(async (key, ball) => {
    const previous = assignments[key];
    setAssignments(prev => ({ ...prev, [key]: ball }));
    try {
      await setRarityBall(key, ball);
    } catch (err) {
      console.error(err);
      setAssignments(prev => ({ ...prev, [key]: previous }));
    }
  }, [assignments]);

  const clearBall = useCallback(async (key) => {
    const previous = assignments[key];
    setAssignments(prev => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
    try {
      await deleteRarityBall(key);
    } catch (err) {
      console.error(err);
      setAssignments(prev => ({ ...prev, [key]: previous }));
    }
  }, [assignments]);

  return { rarityBalls: assignments, setRarityBallOverride: setBall, clearRarityBallOverride: clearBall };
}
